import {Marker} from 'react-map-gl/mapbox';
import { useState } from 'react';
import clsx from 'clsx';

import StatusIcon from './StatusIcon.jsx';
import Placeholder from './Placeholder.jsx';

import styles from './SiteMapMarker.module.css';


function SiteMapMarker({title, value, anchor, status, onMouseEnter, onMouseLeave, onBlur, blip, expanded = true, ...props}) {
  return (
    <Marker anchor={anchor} className={clsx(styles.SiteMarker, expanded && styles['SiteMarker--expanded'], blip && styles['SiteMarker--blip'])} {...props}>
      <div className={clsx(styles.MarkerBlip, styles[`MarkerBlip--${status}`], styles['MarkerBlip--' + anchor], blip && styles['MarkerBlip--visible'], expanded && styles['MarkerBlip--expanded'])}></div>
      <div className={clsx(styles.MarkerContainer, styles[`MarkerContainer--${status}`], styles['MarkerContainer--' + anchor], blip && styles['MarkerContainer--blip'], expanded && styles['MarkerContainer--expanded'])} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onBlur={onBlur}>
        <Placeholder ready={status} className={clsx(styles.MarkerIcon, !expanded && styles['MarkerIcon--mini'])}>
          <StatusIcon status={status} className={clsx(styles.MarkerIcon, !expanded && styles['MarkerIcon--mini'])}  />
        </Placeholder>
        <div className={styles.MarkerContent}>
          <div className={clsx(styles.MarkerTitle, !expanded && styles['MarkerTitle--mini'])}>{title}</div>
          <div className={clsx(styles.MarkerValue, !expanded && styles['MarkerValue--mini'])}>
            <Placeholder ready={value} xs={8}>
              {value}
            </Placeholder>
          </div>
        </div>
      </div>
    </Marker>
  )
}

export default SiteMapMarker
